module.exports = __webpack_public_path__ + "img/sulfite.49de383a.svg";